// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.admin.dataconfiguration.medication.PracticeDrugResponse */
/* istanbul ignore next */
@GandalfModel
export class PracticeDrugResponse extends GandalfModelBase {

	@GandalfProperty({ designType: Number })
	dispensingInfoAmount!: number | null;

	@GandalfProperty({ designType: Number })
	dispensingInfoUnitId!: number | null;

	@GandalfProperty({ designType: Boolean })
	doNotSubstitute!: boolean | null;

	@GandalfProperty({ designType: Number })
	dosageAmount!: number | null;

	@GandalfProperty({ designType: Number })
	dosageUnitId!: number | null;

	@GandalfProperty({ designType: String })
	drugName!: string | null;

	@GandalfProperty({ designType: Number })
	durationAmount!: number | null;

	@GandalfConstantDecorator(constants.DurationUnit)
	@GandalfProperty({ designType: constants.DurationUnit })
	durationUnit!: constants.DurationUnit | null;

	@GandalfProperty({ designType: Number })
	frequencyId!: number | null;

	@GandalfProperty({ designType: String })
	instructions!: string | null;

	@GandalfProperty({ designType: Number })
	numRefillsAllowed!: number | null;

	@GandalfProperty({ designType: Number })
	practiceDrugId!: number | null;

	@GandalfProperty({ designType: Number })
	routeId!: number | null;

}
